export default __webpack_public_path__ + "static/media/hair-6-4.2936198a.svg";